var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page"},[_c('Header',{attrs:{"active-nav":_vm.activeNav},on:{"nav-click":_vm.scrollToSection}}),_c('Carousel',{attrs:{"slides":_vm.slides}}),_c('ContentSection'),_c('Footer',{on:{"scroll-to":_vm.scrollToSection,"show-product":_vm.showProduct}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }